import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { ButtonTypes } from "@iddataweb/idw-common-ui/enums";
import { ChangeEvent, FormEvent, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { InputFormGroup } from "../../common/input-form-group/input-form-group";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import defaultStyles from "../../common/modals/default-modal/default-modal.less";

type AddVerificationWorkflowModalProps = {
    workflowName: string;
    onModalClose: () => void;
    onWorkflowSettingApplied: (workflowName: string) => void;
};

export const AddVerificationWorkflowModalBasic = (props: AddVerificationWorkflowModalProps) => {
    const { workflowName, onModalClose, onWorkflowSettingApplied } = props;
    const [labelWidth] = useState(LabelWidthTypes.MEDIUM);
    const [state, setState] = useState<string>(workflowName);

    const handleWorkflowSubmit = (event: FormEvent) => {
        event.preventDefault();
        onWorkflowSettingApplied(state);
        onModalClose();
    };

    const handleUpdateWorkflowName = (event: ChangeEvent<HTMLInputElement>) => {
        setState(event.target.value);
    };

    return (
        <DefaultModal
            automationId="add-verification-workflow-modal-basic"
            ariaLabelledBy="add-verification-workflow-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
        >
            <Form onSubmit={handleWorkflowSubmit}>
                <Modal.Header id={"add-verification-workflow-title"} closeButton>
                    <Modal.Title>{resources.modals.addVerificationWorkflow.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className={defaultStyles.description}>
                        {'The workflow will not be created until you save the Verification Service'}
                    </span>

                    <InputFormGroup
                        controlId="workflow-name-input"
                        label={resources.modals.addVerificationWorkflow.inputs.name.label}
                        ariaLabel={resources.modals.addVerificationWorkflow.inputs.name.label}
                        automationId="workflow-name-input"
                        placeholder={resources.modals.addVerificationWorkflow.inputs.name.placeholder}
                        value={state || ''}
                        onChange={handleUpdateWorkflowName}
                        disabled={false}
                        isRequired={true}
                        labelWidth={labelWidth}
                    />

                </Modal.Body>
                <Modal.Footer>
                    <Button id="create-workflow-cancel" variant="secondary" onClick={onModalClose}>{resources.common.buttons.cancel.label}</Button>
                    <Button id="create-workflow-submit" variant="primary" type={ButtonTypes.SUBMIT}>{resources.common.inputs.workflow.createWorkflowButtonText}</Button>
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};
